const filterTimeErrorsForEconomyMode = (errors, isEconomyModeEnabled) => {
  const errorsFiltered = {
    ...errors,
  };
  if (isEconomyModeEnabled) {
    Object.keys(errorsFiltered).forEach((errorKey) => {
      if (errorKey.endsWith('time_from') || errorKey.endsWith('time_to')) {
        delete errorsFiltered[errorKey];
      }
    });
  }
  return errorsFiltered;
};

export default filterTimeErrorsForEconomyMode;
